

import packageJson from '../package.json';

import { bootstrapApplication } from '@angular/platform-browser';
import 'hammerjs';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);


document
.querySelector('html')
?.setAttribute('social-sport-version', packageJson.version);